export default __webpack_public_path__ + "static/media/twitter-icon2.a94bb4cb.svg";